export const isEmptyObject = <T = unknown>(value: T) => (
  value === null || !((value && Object.keys(value)) || value).length
);
export const isNotEmptyObject = <T = unknown>(value: T) => !isEmptyObject(value);
export const isNotEmptyObjectInList = (list: unknown[]) => list.some((value) => isNotEmptyObject(value));